import React from "react"
import styled from "styled-components"
import Swiper from "react-id-swiper"

import Article from "./article"

const SwiperContainer = styled.div`
  .swiper-container {
    .swiper-slide {
      padding: 0;
    }
  }
`

const Relateds = ({ posts, hideCategory }) => {
  const swiperParams = {
    slidesPerView: 1,
    watchOverflow: true,
    touchReleaseOnEdges: true,
    spaceBetween: 20,
    pagination: {
      el: `.swiper-pagination`,
      type: `bullets`,
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      },
    },
  }

  return posts ? (
    <SwiperContainer>
      <Swiper {...swiperParams}>
        {posts.map((post, index) => (
          <Article key={post.slug} as="div" post={post} index={index} hideCategory={hideCategory} />
        ))}
      </Swiper>
    </SwiperContainer>
  ) : null
}

export default Relateds
